import { TicketDao } from "../dao";
import { TicketControl, TerminalType } from "../model";

export class TicketService {
  private readonly _ticketDao: TicketDao;

  public constructor(ticketDao: TicketDao) {
    this._ticketDao = ticketDao;
  }

  public async getTicketControlByLicensePlate(
    cityId: string,
    licensePlate: string,
    params?: {
      accuracy?: number;
      latitude?: number;
      longitude?: number;
      scandate?: string;
      terminalType?: TerminalType;
      matricule?: string;
      requestSrc?: string;
    }
  ): Promise<TicketControl> {
    return await this._ticketDao.getTicketControlByLicensePlate(
      cityId,
      licensePlate,
      params
    );
  }
}

export default TicketService;
